exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".domain-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #ffffff;\n  z-index: 99999;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.domain-box {\n  text-align: center;\n  max-width: 600px;\n  padding: 30px;\n  border: 1px solid #ddd;\n  box-shadow: 0 0 10px rgba(0,0,0,0.1);\n}\n\n.domain-box h3 {\n  color: #d9534f;\n  margin-bottom: 15px;\n}\n\n.domain-box ul {\n  list-style: none;\n  padding: 0;\n}\n\n.domain-box ul li {\n  margin: 10px 0;\n}\n\n.domain-box ul li a {\n  color: #337ab7;\n  text-decoration: none;\n  font-weight: bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/header/header.component.css
// module id = ../../../../../src/app/pages/header/header.component.css
// module chunks = main